import React from "react";
import { Link, makeStyles, Text, tokens, typographyStyles } from "@fluentui/react-components";
import { Open20Regular } from "@fluentui/react-icons";
import "./VersionPopover.css";

const useStyles = makeStyles({
  icon: { verticalAlign: "text-bottom" },
  link: {
    ...typographyStyles.body1,
    color: tokens.colorNeutralStrokeOnBrand,
    textDecoration: "underline",
    ":hover": { color: tokens.colorNeutralStroke1 },
  },
  text: { ...typographyStyles.body1, color: tokens.colorNeutralForegroundInverted },
});

interface VersionPopoverProps {
  version?: string;
}

export function VersionPopover({ version = "Unknown" }: VersionPopoverProps) {
  const styles = useStyles();

  return (
    <div className="toolbar__version-popover">
      <div>
        <Text className={styles.text}>
          Styling Assistant is currently in beta and in active development.
          <br />
          Current version: {version}
        </Text>
      </div>
      <div className="toolbar__version-popover-section">
        <Text className={styles.text}>The future of Styling Assistant:</Text>
        <Link className={styles.link}>
          product roadmap <Open20Regular className={styles.icon} />
        </Link>
      </div>
      <div className="toolbar__version-popover-section">
        <Text className={styles.text}>Help improve this tool by</Text>
        <Link className={styles.link}>
          providing your feedback <Open20Regular className={styles.icon} />
        </Link>
      </div>
      <div className="toolbar__version-popover-section">
        <Text className={styles.text}>Questions about Styling Assistant?</Text>
        <Link
          className={styles.link}
          onClick={() => {
            navigator.clipboard.writeText("digitalworkflowsupport@penguinrandomhouse.com");
          }}
        >
          Contact support <Open20Regular className={styles.icon} />
        </Link>
      </div>
    </div>
  );
}
